import React from "react";
import { BillIcon } from "../../../icons";
import { ManualBillActivity } from "../../../api/services";
import { ActivityListItem } from "./ActivityListItem";
import { useManualBillActivity } from "../hooks/useManualBillActivity";
import { ActivitySummaryCell } from "./ActivitySummaryCell";

export const ManualBillActivityItem: React.FC<{
  activity: ManualBillActivity;
}> = ({ activity }) => {
  const { activityDttm } = activity;
  const { title } = useManualBillActivity(activity);
  return (
    <ActivityListItem
      icon={<BillIcon />}
      title={title}
      activityDttm={activityDttm}
    />
  );
};

export const ManualBillActivitySummaryCell: React.FC<{
  activity: ManualBillActivity;
  isGrey: boolean;
}> = ({ activity, isGrey }) => {
  const { title } = useManualBillActivity(activity);
  return (
    <ActivitySummaryCell
      isGrey={isGrey}
      icon={<BillIcon />}
      summary={`${title}`}
    />
  );
};
